import type { Ruleset } from "./types.js";

/**
 * MIS 3005-D:2025 §3.5 — domestic hot water design.
 */
export interface HotWaterRules {
  /** Litres per person per day: Vd,average = litresPerPersonPerDay x N (§3.5.2). */
  readonly litresPerPersonPerDay: number;
  /**
   * Minimum flow temperature (°C) the heat pump must achieve at design conditions
   * when serving a DHW cylinder (§3.5.5).
   */
  readonly minCylinderFlowTempC: number;
  /** Legionella / bacterial growth prevention is mandatory (§3.5.7). */
  readonly bacterialPreventionRequired: boolean;
  /** Cold water inlet temperature assumed for recovery calculations (°C). */
  readonly coldInletTempC: number;
  /** Target stored water temperature (°C). Matches legionella regime. */
  readonly storageTempC: number;
  /** Specific heat of water, kJ/(kg·K). 1 litre water = 1 kg. */
  readonly specificHeatKjPerKgK: number;
  /** Minimum coil area per kW of heat pump DHW output (m²/kW). */
  readonly minCoilAreaM2PerKw: number;
}

export const MIS_3005_D_HOT_WATER: Ruleset<HotWaterRules> = {
  id: "mcs.hot-water",
  version: "1.0.0",
  effectiveFrom: "2025-01-01",
  jurisdictions: ["england", "wales", "scotland", "northern-ireland"],
  provenance: "verified",
  source: {
    standard: "MIS 3005-D:2025",
    issue: "2.0",
    clause: "3.5",
    issued: "2025-12-05",
    url: "https://mcscertified.com/wp-content/uploads/2025/12/MIS-3005-D-2025-V2.0-Final.pdf",
  },
  data: {
    litresPerPersonPerDay: 45,
    minCylinderFlowTempC: 55,
    bacterialPreventionRequired: true,
    coldInletTempC: 10,
    storageTempC: 55,
    specificHeatKjPerKgK: 4.186,
    minCoilAreaM2PerKw: 0.2,
  },
};
